import { z } from 'zod'

import { MailChimpIntegrationSchema } from 'shared/api/common/schemas/mailChimpIntegration'

export const MailChimpSchemas = {
  setAccountLinkField: {
    path: z.undefined(),
    query: z.undefined(),
    request: z.object({ field_id: z.string().nullable(), field_name: z.string().nullable() }),
    response: z.undefined(),
  },
  clearAccountLinkField: {
    path: z.undefined(),
    query: z.undefined(),
    request: z.undefined(),
    response: z.undefined(),
  },
  getLists: {
    path: z.undefined(),
    query: z.undefined(),
    request: z.undefined(),
    response: z.object({ lists: z.array(MailChimpIntegrationSchema) }),
  },
}
